import React from 'react';
import { ButtonV2, Flex } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

export const ShowMoreButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation('accommodationsConsole');
  return (
    <Flex justifyContent="center">
      <ButtonV2
        intent="newPrimary"
        variant="outline"
        onClick={onClick}
      >
        {t('listingsPanel', 'showMore')()}
      </ButtonV2>
    </Flex>
  );
};
